import React from 'react'
import { useSearch } from '../../Hook/App'
import Layout from '../../Layout'
import Spinner from '../../Components/Spinner'
function Search() {
    const { loading, onChange, List, onClick, navigate } = useSearch();
    return (
        <Layout>

            <div className=" header col-lg-4  px-3 home ">
                <div className='flex-between'>

                    <i onClick={() => { navigate(-1) }} className='fas fa-times me-2'></i>
                    <div className="flex-between input-search">
                        <input type="text" onChange={onChange} autoFocus placeholder='جستجو کنید ...' />
                        {loading && <Spinner sm />}
                    </div>
                </div>
                <div style={{ paddingTop: '3rem' }}>
                    {List.map((category, i) => {
                        return <div key={i} onClick={() => {
                            onClick(category)
                        }} className='result-search'><span>{category.title}</span> <i className='far fa-search'></i></div>
                    })}
                </div>
            </div>

        </Layout>
    )
}

export default Search